/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { dailyStatsGetApiV3DailyStatsMaxQueryTransactionsPerSecTillDate } from "../../funcs/dailyStatsGetApiV3DailyStatsMaxQueryTransactionsPerSecTillDate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations
    .GetApiV3DailyStatsMaxQueryTransactionsPerSecTillDateRequest$inboundSchema
    .optional(),
};

export const tool$dailyStatsGetApiV3DailyStatsMaxQueryTransactionsPerSecTillDate:
  ToolDefinition<typeof args> = {
    name:
      "daily-stats-get-api-v3-max-query-transactions-per-sec-till-date",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await dailyStatsGetApiV3DailyStatsMaxQueryTransactionsPerSecTillDate(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
